<template>
  <div class="cp-change-shop main">
    <div v-if="$store.getters.isSuperUser">
      <div class="divider" />

      <div
        class="row"
        style="background-color: #eef"
        @click="goto('/commerce_page/change-shop-superuser')"
      >
        <p><i class="fa fa-mask icon" />Change Shop Superuser</p>
      </div>
    </div>

    <div class="divider" />

    <div class="row">
      <p>
        <i class="fa fa-store-alt icon" />Current Shop
        <span class="tag is-rounded is-pulled-right">
          {{ commerceRoles.length }} Shops</span
        >
      </p>
      <p class="value">
        {{ business.name }}
      </p>

      <div class="list has-text-left" style="margin-top: 10px" :key="z">
        <span
          v-for="(r, i) in commerceRoles"
          :key="i"
          class="list-item super-role"
          :class="{ active: r.active }"
          @click="toggleActive(r)"
        >
          {{ shortenString(r.business.name, 30) }}
          <i
            v-if="r.active"
            class="fa fa-cog fa-spin fa-lg has-text-primary is-pulled-right"
            style="margin-top: 5px"
          />
        </span>
      </div>
    </div>

    <div class="divider" />

    <div class="row" @click="goto('/new_shop')">
      <p>
        <i class="fa fa-plus-circle has-text-success icon" />Create New Shop
      </p>
    </div>

    <!-- <div class="wrapper">
      <div class="field is-grouped" style="margin-bottom: 8px">
        <div class="control is-expanded has-icons-left has-icons-right search">
          <span class="icon is-small is-left">
            <i class="fas fa-search" />
          </span>
          <span
            class="icon is-small is-right"
            style="pointer-events: initial"
            v-show="searchTerm"
            @click="clearSearch"
          >
            <i class="fa fa-times-circle" />
          </span>
          <input
            ref="input"
            class="input"
            type="text"
            v-model="searchVal"
            :placeholder="'Search business'"
            @keyup="search($event)"
            @focus="search($event)"
            @blur="clearSearch"
          />
        </div>
        <div class="control">
          <a class="button"><i class="fa fa-chevron-right" /></a>
        </div>
      </div>
      <div v-if="searchResult.length" class="list is-hoverable search-result">
        <span
          v-for="s in searchResult"
          v-ripple
          class="list-item"
          :key="s.key + s.value"
          @click="chooseBusiness(s.value)"
          >{{ s.key }}</span
        >
      </div>
      <div v-show="showSearching" class="list search-result">
        <span class="list-item">
          <i class="fa fa-spinner fa-spin" />
        </span>
      </div>
      <div v-show="noResults && !showSearching" class="list search-result">
        <span class="list-item is-italic">
          <i>{{ $t("home2.no-results-for") }} "{{ searchTerm }}"</i>
        </span>
      </div>

      <div class="list has-text-left" style="margin-top: 10px" :key="z">
        <span
          v-for="(r, i) in superRoles"
          :key="i"
          class="list-item super-role"
          :class="{ active: r.active }"
          @click="toggleActive(r)"
        >
          {{ shortenString(r.business.name, 30) }}
          <i
            v-if="r.active"
            class="fa fa-cog fa-spin fa-lg has-text-primary is-pulled-right"
            style="margin-top: 5px"
          />
        </span>
      </div> 
    </div> -->
  </div>
</template>

<script>
export default {
  name: "CPChangeShop",
  props: {
    b: Object,
  },
  data() {
    return {
      isSearching: false,
      searchResult: [],
      noResults: false,
      searchVal: null,
      searchTerm: null,
      lastSearch: null, // store last search when searchVal/searchTerm clear
      z: 0, // unnecessary...
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    showSearching() {
      if (this.searchResult.length > 0) return false;
      return this.isSearching;
    },
    superRoles() {
      return this.$store.state.superRoles.filter((r) => r);
    },
    commerceRoles() {
      return this.$store.state.roles.filter(
        (r) => r.role_name === "Commerce Agent" // probably use "Commerce Manager"
      );
    },
  },
  mounted() {
    // this.$nextTick(() => this.$refs.input.focus());
  },
  methods: {
    // activateNextRole() { }, // not used, see ChangeCommerceAgent.vue
    chooseBusiness(businessID) {
      console.log("chooseBusiness", businessID);
      this.getSuperRole(businessID);
    },
    updateSuperRole(businessID) {
      var payload = {
        workflow_type: "Commerce",
        business_id: businessID,
      };
      this.$store
        .dispatch("getBusinessAndWorkflow", payload)
        .then((res) => {
          this.$store.commit("updateSuperRole", res.data);
          this.refreshPage();
        })
        .catch((err) => this.apiError(err));
    },
    getSuperRole(businessID) {
      var payload = {
        workflow_type: "Commerce",
        business_id: businessID,
      };
      this.$store
        .dispatch("getBusinessAndWorkflow", payload)
        .then((res) => {
          console.log("businessAndWorkflow", res.data);
          this.createSuperuserRole(res.data);
        })
        .catch((err) => this.apiError(err));
    },
    createSuperuserRole(data) {
      // this.superRoles.forEach((r) => (r.active = false));
      // no need to check if these exist, will return error if not exist
      var business = data.business;
      var workflow = data.workflows[0]; // could be more than 1?
      var role = {
        business_id: business.id,
        workflow_id: workflow.id,
        role_type: "worker",
        role_name: "Commerce Agent",
        business: business,
        workflow: workflow,
        active: false, // flag to indicate if it's being used now
      };
      this.$store.commit("addSuperRole", role);
      setTimeout(() => {
        var r = this.superRoles.find((r) => r.business_id === role.business_id);
        this.toggleActive(r);
      }, 300);
    },
    clearRoles() {
      this.$store.commit("addSuperRole", null);
    },
    toggleActive(role) {
      this.superRoles.forEach((r) => (r.active = false));
      role.active = true;
      var activating = `Activating <i class='fa fa-atom fa-spin' />`;
      this.infoToast(activating, "top");
      // setTimeout(() => this.close(), 700);
      this.updateSuperRole(role.business_id);
      //   this.$emit("changed"); // get all the latest role / business / workflow etc data needed
      this.goto(`/commerce_home/${role.business_id}`);
    },
    clearSearch() {
      this.searchVal = null;
      this.searchTerm = null;
      this.noResults = false;
      setTimeout(() => (this.searchResult = []), 300);
    },
    search(e) {
      var text = e.target.value; //   var text = this.searchVal;
      this.searchTerm = text; // a hack for mobile...
      this.lastSearch = text;
      console.log("search", text);
      if (text.length < 3) {
        // this.searchResult = [];
        console.log("frequentShops", this.$store.getters.getFrequentShops);
        this.searchResult = this.$store.getters.getFrequentShops.filter((s) =>
          s.key.toLowerCase().includes(text.toLowerCase())
        );
        this.isSearching = false;
        this.noResults = false;
        return;
      }
      this.isSearching = true;
      this.$store
        .dispatch("autocompleteSearch", text)
        .then((res) => {
          if (res.data) {
            if (res.data.businesses) {
              this.searchResult = res.data.businesses;
              this.noResults = false;
            } else {
              this.searchResult = [];
              this.noResults = true;
            }
          } else {
            this.searchResult = [];
            this.noResults = true;
          }
        })
        .catch((err) => console.error("searchAutocomplete", err))
        .finally(() => (this.isSearching = false));
    },
  },
};
</script>

<style scoped>
/* .main {
  width: 100vw;
  max-width: 600px;
  height: 100vh;
  overflow: hidden;
} */
.wrapper {
  padding: 16px;
}
.subtitle {
  text-align: left;
  margin-bottom: 12px;
  /* margin-left: 40px; */
  /* color: #ccc; */
}
.super-role {
  /* background-color: #ddd; */
  background-color: #eee;
  border-bottom: 1px solid #ddd;
}
.active {
  background-color: rgb(227, 255, 227);
}
.search-result {
  text-align: left;
  margin-bottom: 0;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  border-bottom: 1px dotted rgb(230, 230, 230);
}
</style>